import React, { useState } from 'react';
import './form1.css';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import bar from '../../../images/bar.svg';
import { Container, Form, Button, Row, Col, Image, Card } from 'react-bootstrap';
import { skills } from '../../../data';
import tick from '../../../images/tick.svg'
import { Link } from 'react-router-dom';


function Form1() {
  
  const navigate = useNavigate()
  const [checkedItems, setCheckedItems] = useState([]);

  const handleCheckboxChange = (label) => {
    if (checkedItems.includes(label)) {
      setCheckedItems(checkedItems.filter((item) => item !== label));
    } else {
      setCheckedItems([...checkedItems, label]);
    }
  };

  return (
    <Container fluid className='p-0 m-0'>
      <div className='d-flex align-items-center text-center  gap-4 py-5 px-3'>
      <FaArrowLeft className='arrow' onClick={() => navigate("/jobseekersignup")} />
      <h3 className='mt-4'>Back</h3>
      </div>
      <Container fluid className='p-3 p-sm-5' style={{ background: 'rgba(255, 161, 94, 0.55)',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'}}>
        <div className='d-block align-items-center justify-content-center text-center py-3'>
        <Image fluid src={bar} alt='bar' />
        <h2 className='form-head mt-4'>Resume Building</h2>
        </div>
        <Row className='mt-4'>
          
          <Col>
          <Form>
          {skills.map((skill) => (
            <Form.Check className='align-items-center skill-text'
              key={skill.id}
              type="checkbox"
              label={skill.label}
              id={skills.id}
              onChange={() => handleCheckboxChange(skill.label)}
            />
          ))}
        </Form>
          </Col>
          <Col xs={12} md={9}>
          <Card className='flex-column p-3 gap-3 border-0 mb-3 mt-3 mt-sm-0' style={{ background: '#D9D9D9'}}>
          {checkedItems.length > 0 && (
          <div className='d-flex flex-column  gap-1'>
           
            {checkedItems.map((item) => (
              <div className=' p-1 d-flex align-items-center' >
              <p className='skill-text' key={item} style={{background:'#fff'}}>{item} &nbsp;
              <img src={tick} style={{width:'30px', height:'30px'}}/>
              </p>  
              
              </div>
            ))}
          </div>
        )}
          
        </Card>
         <p className='drag-text'>Click on skills you are interested in</p>
          </Col>
        </Row>
        
        <div className='mt-4 d-flex text-center justify-content-center align-items-center mx-3'> 
        <Link to="/form2" className='next-button'>Next
          </Link>
        </div>
       

      </Container>
   
    </Container>
    
    
  );
}

export default Form1;
